<template>
  <div id="app">
    <app-wrapper />
  </div>
</template>

<script>
import AppWrapper from '@components/appWrapper';

export default {
  components: {
    AppWrapper,
  },
};
</script>
